export enum DisplayDimensions {
  MOBILE = 896,
  MOBILE_WITH_ACCOUNT = 950,
  DESKTOP = 1200,
  ACCOUNT_BUTTON_MIN = 1250,
  ACCOUNT_MENU_MIN_HEIGHT = 380,
}
